import PropTypes from 'prop-types';
import { WaveRating, GlobeRating } from '@bwoty-web/styleguide';
import './cruiseListCardHeader.scss';
import './cruiseListCardLink.scss';

const CruiseListCardHeader = ({
  headerContent: {
    link,
    rating,
    titleText,
    itinerarySubTitleText,
    cruiseShipTitleText,
  },
  href,
  onSelect,
  siteId = 1,
}) => {
  return (
    <div className="iw-cruise-list-card-header-container">
      {(href || onSelect) && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
        <a
          href={href}
          onClick={onSelect}
          rel="nofollow"
          className="iw-cruise-list-card__link"
        />
      )}
      <h3 className="iw-cruise-list-card__title">
        {link && link.url ? <a href={link.url} target={link.target}>{titleText}</a> : <span>{titleText}</span>}
      </h3>
      <span className="iw-cruise-list-card__itinerary-subtitle">{itinerarySubTitleText}</span>
      <div className="iw-cruise-list-card__cruise-ship-name-container">
        <h4 className="iw-cruise-list-card__cruise-ship-name">{cruiseShipTitleText}</h4>
        {rating && (
          <>
            {siteId === 18 ? (
              <GlobeRating
                rating={rating}
                responsive
              />
            ) : (
              <WaveRating
                rating={rating}
                responsive
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

CruiseListCardHeader.propTypes = {
  headerContent: PropTypes.shape({
    link: PropTypes.shape({
      url: PropTypes.string,
      target: PropTypes.string,
    }),
    rating: PropTypes.number,
    titleText: PropTypes.string,
    itinerarySubTitleText: PropTypes.string,
    cruiseShipTitleText: PropTypes.string,
  }),
  href: PropTypes.string,
  onSelect: PropTypes.func,
  siteId: PropTypes.number,
};

CruiseListCardHeader.defaultProps = {
  headerContent: {
    link: {
      url: null,
      target: null,
    },
    rating: null,
    titleText: '',
    cruiseShipTitleText: '',
  },
  href: null,
  onSelect: null,
  siteId: 1,
};

export default CruiseListCardHeader;
